module.exports = __webpack_public_path__ + "media/theme/tutorial__itunes_2019--4-7a0b9781.png";